import { useState } from 'react';
import { Button, Card, Checkbox, Col, Divider, Flex, Form, Input, Row, Switch } from 'antd';
import type { FormProps } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

// services
import NotificationService from 'core/services/notification';

// components
import PageTitle from 'components/title/title';
import FormElement from 'components/formElement/formElement';
import PhoneInputComponent, { PhoneInputReturn } from 'components/phoneInput/phoneInput';
import { checkPhoneValidation } from 'utils/validators/phone';
import SelectElement from 'components/selectElement/selectElement';
import DatePickerElement from 'components/datePicker/datePicker';
import { NATIONALITIES } from 'utils/nationalities';
import { isRTL } from 'core/services/language';
import StatusComponent from 'components/status/status';
import Icon from 'utils/icon';
import DisabledElement from 'components/disabledElement/disabledElement';
import dayjs from 'dayjs';
import BackButton from 'components/backButton/backButton';

function BusinessMortgageViewPage() {
	const navigate = useNavigate();
	const { t } = useTranslation();

	const [availableShares, setAvailableShares] = useState<number>(57);
	const [isReleaseLoading, setIsReleaseLoading] = useState(false);

	type createFieldType = {
		commercial_reg: number;
		name: string;
		phone: number;
		national_id: number;
		board: string;
		executive: boolean;
		birthdate: string;
		nationality: string;
		founder: boolean;
	};

	return (
		<>
			<PageTitle name={t('TITLE.CREATE_MORTGAGE')} />

			<BackButton />

			<Card className="mt-3">
				<div className="mb-3">
					<Flex align="center" gap={20}>
						<h5 className="mb-0">{t('MORTGAGE.REQUEST')} #123456</h5>
						<StatusComponent small text={t('COMMON.ACTIVE')} color="green" />
					</Flex>
					<p className="text-light">30th June, 3:00PM</p>
				</div>

				<Row gutter={[16, 16]}>
					<Col span={24} md={12}>
						<FormElement disabled fullWidth type="number" name="nationalId" label={t('COMMON.NATIONAL_ID')} rules={[{ required: true }]} />
					</Col>

					<Col span={24} md={12}>
						<FormElement
							disabled
							fullWidth
							type="number"
							name="commercial_reg"
							label={t('MORTGAGE.COMMERCIAL_REGISTRATION_NUMBER')}
							rules={[{ required: true }]}
						/>
					</Col>
				</Row>

				<Divider />

				<Row gutter={[16, 16]}>
					<Col span={24} md={12} lg={8}>
						<FormElement disabled fullWidth type="text" name="fullname" label={t('COMMON.FULL_NAME')} rules={[{ required: true }]} />
					</Col>

					<Col span={24} md={12} lg={8}>
						<Form.Item name="phone">
							<PhoneInputComponent disabled />
						</Form.Item>
					</Col>

					<Col span={24} md={12} lg={8}>
						<FormElement disabled fullWidth type="text" name="national_id" label={t('COMMON.NATIONAL_ID')} rules={[{ required: true }]} />
					</Col>

					<Col span={24} md={12} lg={8}>
						<DisabledElement label={t('MORTGAGE.BOARD')} value={t('MORTGAGE.MEMBER')} />
					</Col>

					<Col span={24} md={12} lg={8}>
						<DisabledElement label={t('COMMON.EXECUTIVE')} value={t('COMMON.YES')} />
					</Col>

					<Col span={24} md={12} lg={8}>
						<DatePickerElement disabled label={t('COMMON.DATE_OF_BIRTH')} value={dayjs()} onChange={() => {}} />
					</Col>

					<Col span={24} md={12} lg={8}>
						<DisabledElement label={t('MORTGAGE.NATIONALITY')} value={isRTL() ? NATIONALITIES[0].ar : NATIONALITIES[0].en} />
					</Col>

					<Col span={24} md={12} lg={8}>
						<DisabledElement label={t('COMMON.FOUNDER')} value={t('COMMON.YES')} />
					</Col>
				</Row>

				<Card className="mt-5">
					<Flex align="center" gap={10}>
						{/* <img src={sample1} alt="company" style={{ width: 40, height: 40, borderRadius: '50%' }} /> */}
						<h6 className="fw-semibold mb-0">Company X</h6>
					</Flex>
				</Card>

				<div className="mt-5">
					<h6>{t('COMMON.MORTGAGED_SHARES')}</h6>

					<Row gutter={[16, 16]} className="mt-">
						<Col span={24} md={12}>
							<DisabledElement label={t('MORTGAGE.TOTAL_SHARES_NUM')} value="1300" />
						</Col>

						<Col span={24} md={12}>
							<DisabledElement label={t('MORTGAGE.MATURITY_DATE')} value="December 21, 2023" />
						</Col>
					</Row>
				</div>

				<Flex justify="flex-end" className="mt-5">
					<Button type="primary" className="px-4" size="middle">
						{t('MORTGAGE.RELEASE_MORTGAGE')}
					</Button>
				</Flex>
			</Card>
		</>
	);
}

export default BusinessMortgageViewPage;
